import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import ChildDashboardChartComponent from "../components/child/1_ChildDashboardChartComponent";

const ChildMetricPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        {/* <Breadcrumb title="Home" /> */}

        {/* DashBoardLayerOne */}
        <ChildDashboardChartComponent />

      </MasterLayout>
    </>
  );
};

export default ChildMetricPage;
